
<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Zwei-Faktor-Authentifizierung</h1>

    <div class="mb-2">
      <label class="col-sm-2 col-form-label col-form-label-sm ms-3" for="verificationCode" i18n
        >Authentifizierungscode</label
      >
      <input
        type="text"
        id="verificationCode"
        lass="form-control form-control-sm"
        [(ngModel)]="verificationCode"
      />
    </div>
    <button class="btn btn-primary m-2" type="button" [asyncClick]="verify.bind(this)" [disabled]="verifyBtn.disabled" #verifyBtn="asyncClick" i18n>
      @if (verifyBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Senden
    </button>
  </div>
</div>
